var _defs, _path, _path2, _polyline, _polyline2, _path3, _circle, _polyline3, _circle2, _polyline4, _circle3, _line, _circle4, _polyline5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcessedFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\xD1\\xEB\\xEE\\xE9_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1190.61 1340.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{stroke:#282f39;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5{fill:none;stroke-width:17.01px;}.cls-1,.cls-3,.cls-4,.cls-5{fill-rule:evenodd;}.cls-1,.cls-4{stroke-miterlimit:22.93;}.cls-2,.cls-3,.cls-4,.cls-5{stroke-linecap:round;}.cls-2,.cls-3,.cls-5{stroke-linejoin:round;}.cls-4,.cls-5{stroke:#000;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M592.79,209.7c-252.71,1.35-457.15,206.63-457.15,459.65,0,190.25,115.59,353.51,280.36,423.38M592.86,1129c.81,0,1.63,0,2.44,0,253.86,0,459.66-205.8,459.66-459.66,0-189.96-115.23-353-279.6-423.05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M593.05,1256.15c.75,0,1.5,0,2.25,0,223.08,0,417.09-124.48,516.35-307.78M1141.41,884.49c26.26-66.62,40.69-139.19,40.69-215.14,0-17.24-.75-34.32-2.21-51.19M1158.97,505.76c-5.07-17.51-10.95-34.68-17.57-51.48M592.79,82.56c-222.83.94-416.34,126.07-514.9,309.76M48.08,457.06c-25.56,65.83-39.58,137.43-39.58,212.29,0,17.9.81,35.63,2.38,53.15M32.27,835.03c5.13,17.43,11.04,34.53,17.71,51.26"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "592.83 82.57 592.83 8.5 808.83 147.71 592.83 285.71 592.83 209.69"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "592.83 1128.99 592.83 1055.27 365.43 1193.87 592.83 1332.47 592.83 1256.18"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M561.76,346.79h67.08c7.6,0,12.43,6.35,13.82,13.82,4.05,21.78,7.46,77.32,27.3,90.1,8.63,2.93,17.03,6.36,25.17,10.25l2.72,1.33c23.05,5.07,64.79-31.85,83.07-44.4,6.27-4.3,14.17-5.37,19.54,0l23.05,23.05,24.39,24.39c5.37,5.37,4.3,13.28,0,19.54-12.55,18.28-49.47,60.03-44.4,83.08.59,1.19,1.17,2.38,1.73,3.59,3.19,6.76,6.07,13.7,8.61,20.8.42,1.17.84,2.33,1.24,3.51,12.78,19.84,68.31,23.25,90.1,27.29,7.47,1.39,13.82,6.22,13.82,13.82v67.08c0,7.6-6.35,12.43-13.82,13.82-21.79,4.05-77.32,7.46-90.1,27.3-.4,1.18-.82,2.34-1.24,3.51-2.54,7.1-5.42,14.04-8.61,20.8l-1.73,3.58c-5.07,23.05,31.85,64.79,44.4,83.07,4.3,6.27,5.37,14.17,0,19.54l-23.05,23.05-24.39,24.39c-5.37,5.37-13.28,4.3-19.54,0-18.28-12.55-60.04-49.47-83.09-44.39l-2.72,1.33c-6.98,3.33-14.15,6.32-21.49,8.95-1.22.44-2.44.87-3.66,1.29-19.84,12.78-23.25,68.31-27.3,90.1-1.39,7.47-6.22,13.82-13.82,13.82h-67.08c-7.6,0-12.43-6.35-13.82-13.82-4.05-21.79-7.46-77.32-27.29-90.1-.81-.28-1.61-.57-2.42-.85-7.7-2.71-15.22-5.81-22.53-9.29l-2.94-1.43c-23.05-5.07-64.8,31.84-83.08,44.4-6.26,4.3-14.17,5.37-19.54,0l-23.05-23.05-24.39-24.39c-5.37-5.37-4.3-13.28,0-19.54,12.56-18.28,49.48-60.02,44.4-83.07-.34-.7-.7-1.39-1.03-2.09-3.62-7.53-6.83-15.28-9.64-23.23-.3-.86-.61-1.71-.91-2.57-12.78-19.84-68.31-23.25-90.1-27.3-7.47-1.39-13.82-6.22-13.82-13.82v-67.08c0-7.6,6.35-12.43,13.82-13.82,21.78-4.05,77.31-7.46,90.09-27.29.29-.87.61-1.72.91-2.58,2.81-7.95,6.02-15.71,9.64-23.24.34-.7.69-1.39,1.03-2.09,5.06-23.05-31.85-64.78-44.41-83.06-4.3-6.27-5.37-14.17,0-19.54l23.05-23.05,24.39-24.39c5.37-5.37,13.28-4.3,19.54,0,18.27,12.54,59.97,49.43,83.03,44.42l2.97-1.45c8.09-3.86,16.45-7.26,25.03-10.17,19.79-12.84,23.2-68.31,27.24-90.08,1.39-7.47,6.22-13.82,13.82-13.82Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 612.47,
    cy: 810.63,
    r: 45.69,
    transform: "translate(-403.45 798.59) rotate(-52.25)"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "584.54 774.46 528.78 717.35 447.08 717.44"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 563.07,
    cy: 530.35,
    r: 45.69,
    transform: "translate(-37.86 1017.38) rotate(-82.31)"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "535.14 566.51 479.38 623.62 447.18 623.59"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 709.85,
    cy: 670.49,
    r: 45.69,
    transform: "translate(-16.9 1322.62) rotate(-85.27)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 664.16,
    y1: 670.49,
    x2: 435.06,
    y2: 672.36
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 684.27,
    cy: 553.84,
    r: 37.47,
    transform: "translate(-146.6 844.74) rotate(-58.28)"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "659.93 582.33 615.85 627.77 518.68 628.91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessedFileIcon);
export default __webpack_public_path__ + "static/media/processedFileIcon.3ab668d799e3d5895544c7cea3b470b8.svg";
export { ForwardRef as ReactComponent };